import ActionsForm from '@/shared/mixins/actionsForm'
import searchmiscellaneousreimbursement from './components/searchmiscellaneousreimbursement/searchmiscellaneousreimbursement.vue'
import FilterSeveralContributor from './components/FilterSeveralContributor/FilterSeveralContributor.vue'
import Tablesearchmiscellaneousreimbursement from './components/tablesearchmiscellaneousreimbursement/tablesearchmiscellaneousreimbursement.vue'
import detailsmiscellaneousreimbursement from './components/detailsmiscellaneousreimbursement/detailsmiscellaneousreimbursement.vue'
import tablecollaborator from './components/tablecollaborator/tablecollaborator.vue'
import tablepaidlots from './components/tablelotspaid/tablepaidlots.vue'
import Filtermiscellaneouslots from './components/Filtermiscellaneouslots/Filtermiscellaneouslots.vue'
import FirstAdvanceMiscellaneous from './components/FirstAdvanceMiscellaneous/FirstAdvanceMiscellaneous.vue'
import painelFirstAdvanceMiscellaneous from './components/FirstAdvanceMiscellaneous/painelFirstAdvanceMiscellaneous.vue'
import DetailsCollaborator from './components/detailscollaborator/detailscollaborator.vue'
import EncerramentoDiversos from './components/encerramentodiversos/encerramentodiversos.vue'
import Tools from '@/components/tools/Tools.js'
import VisaoGeralDespesas from '@/views/private/finance/expenses/travelexpensezpag/components/VisaoGeralDespesas/VisaoGeralDespesas.vue'
import MiscellaneousExpensesRepository from '@/shared/http/repositories/business/miscellaneousexpenses'

export default {
  name: 'miscellaneousreimbursement',
  components: {
    searchmiscellaneousreimbursement,
    FilterSeveralContributor,
    Tablesearchmiscellaneousreimbursement,
    detailsmiscellaneousreimbursement,
    tablecollaborator,
    tablepaidlots,
    Filtermiscellaneouslots,
    FirstAdvanceMiscellaneous,
    painelFirstAdvanceMiscellaneous,
    DetailsCollaborator,
    EncerramentoDiversos,
    VisaoGeralDespesas
  },
  mixins: [ActionsForm],
  computed: {
    // Abas na ordem do b-tabs. Colaboradores, Lotes Pagos e Primeiro Adiantamento dependem de role
    // (mesmo gate dos v-if do template), entao o indice numerico muda por usuario; tudo que decide
    // aba usa a chave. ZPG-15 levou Processo de Desligamento e Encerramento de Diversos para o fim.
    abas () {
      var autorizacoes = this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) ||
                         this.hasRole(this.roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)
      return ['prestacao']
        .concat(autorizacoes ? ['colaboradores', 'lotes', 'primeiroAdiantamento'] : [])
        .concat(['desligamento', 'encerramento'])
    },
    aba () {
      return this.abas[this.tabIndex] || 'prestacao'
    },
    // Mesmo gate das abas de Autorizacoes desta tela — quem aprova Diversos e a Controladoria, e a
    // role e OUTRA que a de Viagem. Aparece em toda empresa: o clique troca de empresa nesta aba, e
    // sem o quadro em todas nao ha como voltar para a base.
    mostraVisaoGeral () {
      return this.hasRole(this.roles.RW_REAL_ESTA_ADMIN) ||
             this.hasRole(this.roles.ACC_FIN_MISCELLANEOUS_SEARCH_CONTROLLER_APPROVAL)
    }
  },
  data () {
    return {
      tabs: 0,
      details: false,
      despesasid: null,
      filtroEmpresa: null,
      tabIndex: 0,
      dataDetails: {},
      totalDespesas: 0,
      prestacao: false,
      local: '',
      pendingFilter: null
    }
  },

  // ZC-46: o botao Retornar da tela de lotes do colaborador usa `$router.back()`, entao volta para
  // ESTA tela -- mas a aba resetava para 0 e o Rodrigo caia em "Prestacao de Conta" em vez de
  // "Colaboradores", que e de onde ele veio.
  //
  // Por que NAO e um `$router.push('/despesa/diversos?aba=2')` no botao: as duas telas de Diversos
  // compartilham a MESMA tela de lotes, e o indice da aba Colaboradores e diferente em cada uma
  // (1 aqui desde o ZPG-15, 0 na `miscellaneousreimbursementconsulta`). Alem disso a rota `/despesa/diversos`
  // exige role de escrita, que o usuario de consulta nao tem -- push fixo mandaria ele para uma
  // rota que o guard barra. Guardar o indice por rota resolve as duas com o mesmo codigo.
  //
  // `sessionStorage` e nao `localStorage`: a aba certa e a da navegacao corrente, nao uma
  // preferencia que sobrevive semanas.
  created () {
    try {
      var salvo = sessionStorage.getItem('abaDiversos:' + this.$route.path)
      if (salvo !== null && !isNaN(parseInt(salvo, 10))) this.tabIndex = parseInt(salvo, 10)
    } catch (e) { /* navegador sem storage: segue no default */ }
  },
  watch: {
    tabIndex (valor) {
      try {
        sessionStorage.setItem('abaDiversos:' + this.$route.path, String(valor))
      } catch (e) { /* idem */ }
    }
  },
  methods: {
    AtualizaPrestacao (value) {
      this.prestacao = value
    },
    edit (data) {
      MiscellaneousExpensesRepository.GetUsuarioGrupoDespesaViagem()
        .then((Response) => {
          if (Response.data.data.coordenadorId === null && Response.data.data.tecnicoId === null) {
            this.despesasid = data.funcionarioId
            this.details = true
            this.dataDetails = data
          } else if ((Response.data.data.coordenadorId !== null || Response.data.data.tecnicoId !== null) && data.statusDespesa === 1) {
            this.despesasid = data.funcionarioId
            this.details = true
            this.dataDetails = data
          }
        })
    },
    filtro (data) {
      this.filtroEmpresa = data.EmpresaId
    },
    backTable (options) {
      // Quando o componente Tablesearchmiscellaneousreimbursement é remountado
      // (porque tem v-if="!details"), ele lê pendingFilter via prop initialFilter
      // no data() inicial — então o formSearch já parte filtrado.
      if (options && options.applyDirectoryFilter) {
        this.pendingFilter = { StatusDespesa: 3 }
      } else {
        this.pendingFilter = null
      }
      this.details = false
    },
    // O quadro ja trocou a empresa (sessionStorage + Vuex) antes de emitir. Aqui a tela recarrega no
    // escopo novo. `status` null = clique no cartao (traz tudo); com valor = clique na sigla.
    // Passa pelo componente de busca para o select de Situacao refletir o filtro que esta valendo —
    // senao a tela filtra e o formulario diz "Selecione". O campo aqui e `StatusDespesa`, nao
    // `Situacao`: e o contrato do searchmiscellaneousreimbursement:96, diferente do de Viagem.
    onNavegar ({ status }) {
      const busca = this.$refs.SearchRef
      if (busca && busca.form && busca.form.situacao) {
        busca.form.situacao.value = status
        busca.Search()
        return
      }
      // aba sem o componente de busca montado: aplica direto no escopo da aba ativa
      this.search({ StatusDespesa: status })
    },
    search (data) {
      if (this.aba === 'prestacao') {
        this.$refs.tablesearchmiscellaneousreimbursement.formSearch = data
        this.$refs.tablesearchmiscellaneousreimbursement.onLoad()
      }
      if (this.aba === 'desligamento') {
        this.$refs.detailscollaborator.formSearch = data
        this.$refs.detailscollaborator.onLoad()
      }
      if (this.aba === 'encerramento') {
        this.$refs.encerramentodiversos.formSearch = data
        this.$refs.encerramentodiversos.onLoad()
      }
      if (this.aba === 'colaboradores') {
        this.$refs.tablecollaborator.formSearch = data
        this.$refs.tablecollaborator.onLoad(this.$refs.tablecollaborator.formSearch)
      }
      if (this.aba === 'lotes') {
        this.$refs.diversosLotes.dataSearch = data
        this.$refs.diversosLotes.Onload(this.$refs.diversosLotes.dataSearch)
      }
      if (this.aba === 'primeiroAdiantamento') {
        this.$refs.primeiroAdiantamento.dataSearch = data
        this.$refs.primeiroAdiantamento.Onload(this.$refs.primeiroAdiantamento.dataSearch)
      }
    },
    formatMoney (value) {
      return Tools.formatMoney(value)
    },
    totalFuncionarioDespesas (data) {
      this.$emit('totalFuncionarioDespesas', data)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/miscellaneousreimbursement.js